export const PENDING_ACTIVATION_LIST = "PENDING_ACTIVATION_LIST";
export const PENDING_ACTIVATION_SUCCESSFULL = "PENDING_ACTIVATION_SUCCESSFULL";
export const PENDING_ACTIVATION_FAILED = "PENDING_ACTIVATION_FAILED";
export const PENDING_ACTIVATION_ADD = "PENDING_ACTIVATION_ADD";
export const PENDING_ACTIVATION_ADD_SUCCESSFULL = "PENDING_ACTIVATION_ADD_SUCCESSFULL";
export const RESET_DATA = "RESET_DATA";

